import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import OnboardingPage from "./OnboardingPage";
import { api } from "../lib/api";

export default function FiscalProfilePage() {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/fiscal-profile")
      .then((response) => setProfile(response.data))
      .catch((issue) => setError(issue.response?.data?.detail || "No pudimos cargar tu perfil."));
  }, []);

  if (error) {
    return <AppShell><div className="profile-status" data-testid="fiscal-profile-error">{error}</div></AppShell>;
  }

  if (!profile) {
    return <AppShell><div className="profile-status" data-testid="fiscal-profile-loading">Cargando tu perfil fiscal...</div></AppShell>;
  }

  return <AppShell><OnboardingPage initialAnswers={profile} editMode onFinished={() => navigate("/")} /></AppShell>;
}